export const environment = {
  production: true,
  //urlApi: 'http://10.100.10.54:3200/cafe'
  //urlApi: 'http://10.100.10.30:5010/cafe'
  //urlApi: 'http://3.137.202.147:5010/cafe'
  urlApi: 'https://lacafe.granjazul.com/cafe'
};
